import { useEffect, useRef, useState } from 'react';
import { openTelegramLink } from '@ywwwtseng/tma-react-kit';
import clsx from 'clsx';

interface MarqueeProps {
  messages: { text: string; event: { type: string; message: string } }[];
  speed?: number; // 滾動速度，px/s
  className?: string;
}

export const Marquee: React.FC<MarqueeProps> = ({
  messages,
  speed = 50,
  className,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const [offset, setOffset] = useState(0);
  const [contentWidth, setContentWidth] = useState(0);

  // 重新計算內容寬度
  useEffect(() => {
    if (!contentRef.current) return;
    setContentWidth(contentRef.current.scrollWidth / 2); // 單份內容寬度
    setOffset(0);
  }, [messages.join(',')]);

  useEffect(() => {
    if (contentWidth === 0) return;

    let animationFrame: number;
    let lastTime = performance.now();

    const tick = (time: number) => {
      const delta = time - lastTime;
      lastTime = time;
      setOffset((prev) => {
        const next = prev + (speed * delta) / 1000;
        return next > contentWidth ? 0 : next; // 超過單份內容重置
      });
      animationFrame = requestAnimationFrame(tick);
    };

    animationFrame = requestAnimationFrame(tick);
    return () => {
      cancelAnimationFrame(animationFrame);
    };
  }, [contentWidth, speed]);

  return (
    <div
      ref={containerRef}
      className={clsx('overflow-hidden whitespace-nowrap', className)}
    >
      <div
        ref={contentRef}
        className="inline-block"
        style={{ transform: `translateX(-${String(offset)}px)` }}
      >
        {[...messages, ...messages].map(({ text, event }, i) => (
          <span className="mr-4" key={i} onClick={() => {
            const message = JSON.parse(event.message);

            if (event.type === 'gift_sent') {
              if (message.tg_chat_username && message.message_id) {
                console.log(`https://t.me/${message.tg_chat_username}/${message.message_id}`);
                openTelegramLink(`https://t.me/${message.tg_chat_username}/${message.message_id}`);
              } else if (message.tg_chat_username) {
                console.log(`https://t.me/${message.tg_chat_username}`);
                openTelegramLink(`https://t.me/${message.tg_chat_username}`);
              }
            }
          }}>
            {text}
          </span>
        ))}
      </div>
    </div>
  );
};
